<template>
  <div>
    <div v-if="!isLoading" class="building-owner-form mx-5">
      <b-row class="mb-5 mb-sm-4 mx-sm-0">
        <b-col sm="3" md="2">
          <label>{{ $t("general.Civilité") }}</label>
          <b-form-select
            :value="recipient.gender"
            :options="genderOptions"
            @change="updateRecipient('gender', $event)"
          />
        </b-col>
        <b-col sm="4" md="3">
          <label>{{ $t("general.Nom") }}</label>
          <ValidationProvider
            ref="vee-recipient-lastname"
            v-slot="{ errors, classes }"
            :name="'nom'"
            rules="required"
          >
            <b-input :value="recipient.lastname" @input="updateRecipient('lastname', $event)" />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col sm="4" md="3">
          <label>{{ $t("general.Prénom") }}</label>
          <ValidationProvider
            ref="vee-recipient-firstname"
            v-slot="{ errors, classes }"
            :name="'nom'"
            rules="required"
          >
            <b-input :value="recipient.firstname" @input="updateRecipient('firstname', $event)" />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>

        <b-col sm="6" md="4">
          <ValidationProvider
            ref="vee-recipient-email"
            v-slot="{ errors, classes }"
            :name="'email'"
            :rules="recipient.contact_type == contactTypes.email ? 'required|email' : 'email'"
          >
            <label>{{ $t("general.Email") }}</label>
            <b-input :value="recipient.email" @input="updateRecipient('email', $event)" />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <!-- street nb | street | address second -->
      <b-row class="mb-5 mb-sm-4 mx-sm-0">
        <b-col sm="6" md="6">
          <label>Adresse</label>
          <ValidationProvider
            ref="vee-recipient-address"
            v-slot="{ errors, classes }"
            :name="'adresse'"
            rules="required"
          >
            <b-input :value="recipient.address" @input="updateRecipient('address', $event)" />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col sm="6" md="6">
          <label>{{ $t("general.Complément") }}</label>
          <b-input :value="recipient.complement" @input="updateRecipient('complement', $event)" />
        </b-col>
      </b-row>
      <!-- zipcode | city | country -->
      <b-row class="mb-5 mb-sm-4 mx-sm-0">
        <b-col sm="3" md="2">
          <label>{{ $t("general.Code_postal") }}</label>
          <ValidationProvider
            ref="vee-recipient-zipcode"
            v-slot="{ errors, classes }"
            :name="'code postal'"
            rules="required"
          >
            <b-input :value="recipient.zipcode" @input="updateRecipient('zipcode', $event)" />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col sm="4" md="3">
          <label>Ville</label>
          <ValidationProvider
            ref="vee-recipient-city"
            v-slot="{ errors, classes }"
            :name="'ville'"
            rules="required"
          >
            <b-input :value="recipient.city" @input="updateRecipient('city', $event)" />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col sm="4" md="3">
          <label>{{ $t("general.Pays") }}</label>
          <ValidationProvider
            ref="vee-recipient-country"
            v-slot="{ errors, classes }"
            :name="'pays'"
            rules="required"
          >
            <b-form-select
              :value="recipient.country"
              :options="countryOptions"
              @input="updateRecipient('country', $event)"
            >
              <template #first>
                <b-form-select-option :value="''" disabled>Choisissez le pays</b-form-select-option>
              </template>
            </b-form-select>
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>

        <b-col sm="5" md="4">
          <label>Complément 2</label>
          <b-input :value="recipient.complement2" @input="updateRecipient('complement2', $event)" />
        </b-col>
      </b-row>
      <!-- contact type -->
      <b-row class="mb-4 mx-sm-0">
        <b-col sm="6" md="5">
          <label>{{ $t("general.Type_d_envoi_prefere") }}</label>
          <ValidationProvider
            ref="vee-recipient-contact_type"
            v-slot="{ errors, classes }"
            :name="'type d’envoi préféré'"
            rules="required"
          >
            <b-form-select
              :value="recipient.contact_type"
              :options="contactTypeOptions"
              @change="updateRecipient('contact_type', $event)"
            />
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row class="mt-5 mb-2 justify-content-between">
        <b-col cols="auto">
          <b-button
            v-if="existentRecipient"
            class="button btn-danger ml-3"
            title="Supprimer le destinataire"
            @click="deleteRecipient"
          >
            <font-awesome-icon icon="user-times" />
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button class="button btn-grey mr-2" @click="close">Fermer</b-button>
          <b-button class="button btn-blue mr-3" @click="addRecipient">
            <font-awesome-icon icon="save" />
            <span class="ml-2">{{ $t("general.enregistrer") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <appLoader v-else />
  </div>
</template>
<script>
import { validate } from "vee-validate";
import { mapState } from "vuex";
import RecipientORM from "@/store/orm-axios/models/Recipient";
import RecipientMW from "@/middlewares/Recipient";
export default {
  props: {
    buildingOwnerId: {
      type: String,
      required: true,
    },
    buildingId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      isLoading: false,
      recipient: {
        building_owner_id: this.buildingOwnerId,
        building_id: this.buildingId,
        firstname: "",
        lastname: "",
        gender: 1,
        email: "",
        address: "",
        complement: "",
        complement2: "",
        zipcode: "",
        city: "",
        country: "",
        contact_type: 1,
        agency_id: Number(localStorage.getItem("agencyId")),
      },
    };
  },
  computed: {
    allCountries() {
      return this.$store.getters.getCountries;
    },
    countryOptions() {
      let result = [];
      this.allCountries.forEach(element => {
        result.push({
          value: element.countryCode,
          text: element.countryName,
        });
      });
      return result;
    },
    existentRecipient() {
      return RecipientORM.query()
        .where("building_id", this.buildingId)
        .where("building_owner_id", this.buildingOwnerId)
        .first();
    },
  },
  created() {
    if (this.existentRecipient) {
      this.recipient = this.existentRecipient;
    }
  },
  methods: {
    close() {
      this.$emit("closeModal");
    },
    updateRecipient(key, value) {
      this.recipient[key] = value;
    },
    async addRecipient() {
      if (!(await this.validateStep())) {
        return;
      }
      this.isLoading = true;
      if (this.recipient.id) {
        RecipientMW.PUT(this.recipient)
          .then(() => {
            this.close();
          })
          .catch(err => {
            this.isLoading = false;
            console.log("err", err);
          });
      } else {
        RecipientMW.POST(this.recipient)
          .then(() => {
            this.close();
          })
          .catch(err => {
            this.isLoading = false;
            console.log("err", err);
          });
      }
    },
    deleteRecipient() {
      this.isLoading = true;
      RecipientMW.DELETE(this.existentRecipient)
        .then(() => {
          this.close();
        })
        .catch(err => {
          this.isLoading = false;
          console.log("err", err);
        });
    },
    async validateStep() {
      var valid = true;
      let values = [
        {
          key: "lastname",
          rules: "required",
        },
        {
          key: "firstname",
          rules: "required",
        },
        {
          key: "address",
          rules: "required",
        },
        {
          key: "zipcode",
          rules: "required",
        },
        {
          key: "city",
          rules: "required",
        },
        {
          key: "country",
          rules: "required",
        },
        {
          key: "contact_type",
          rules: "required",
        },
        {
          key: "email",
          rules: this.recipient.contact_type == this.contactTypes.email ? "required" : "",
        },
      ];
      for (const value of values) {
        await validate(this.recipient[value.key], value.rules, {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["vee-recipient-" + value.key].validate();
          }
        });
      }
      return valid;
    },
  },
};
</script>
